export default __webpack_public_path__ + "static/media/049-wristwatch.0b553e60.svg";